var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',{attrs:{"layout":"C"}},[(true)?_c('IndexPageableTree'):_vm._e(),(false)?_c('IndexVxe'):_vm._e(),(false)?_c('IndexMultiselect'):_vm._e(),(false)?_c('IndexSingleselect'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }